/**
 * 我的分析
 */
export default {
  dbl_myAnalysis_title: "图表中心",
  dbl_myAnalysis_new: "新增图表",
  dbl_myAnalysis_search_task: "搜索任务名",
  dbl_myAnalysis_task_permissions: "任务权限",
  dbl_myAnalysis_visible_to_me_only: "仅自己可见",
  dbl_myAnalysis_visible_to_business: "业务可见",
  dbl_myAnalysis_task_tags: "图表标签",
  dbl_myAnalysis_table_task_tags: "图表标签",
  dbl_myAnalysis_task_name: "任务名",
  dbl_myAnalysis_task_permission: "任务权限",
  dbl_myAnalysis_status: "状态",
  dbl_myAnalysis_creation_time: "创建时间",
  dbl_myAnalysis_person_in_charge: "负责人",
  dbl_myAnalysis_actions: "操作",
  dbl_myAnalysis_edit: "编辑",
  dbl_myAnalysis_view: "查看",
  dbl_myAnalysis_publish: "发布",
  dbl_myAnalysis_share: "分享",
  dbl_myAnalysis_delete: "删除",
  dbl_myAnalysis_copy_chart_title: "复制图表",
  dbl_myAnalysis_copy_success: "复制成功",
  dbl_myAnalysis_copy_fail: "复制失败，错误码：{code}",
  dbl_myAnalysis_total: "共 {total} 项",
  dbl_myAnalysis_share_success: "分享成功",
  dbl_myAnalysis_delete_success: "删除成功",

  dbl_myAnalysis_published: "已发布",
  dbl_myAnalysis_unpublished: "未发布",

  // 发布设置弹窗
  dbl_myAnalysis_publish_set: "发布设置",
  dbl_myAnalysis_publish_filter_default: "筛选器默认设置",
  dbl_myAnalysis_publish_detail: "发布详情设置",
  dbl_myAnalysis_publish_dashboard_en: "报表名英文名",
  dbl_myAnalysis_publish_dashboard_en_placeholder: "请输入报表英文名",
  dbl_myAnalysis_publish_dashboard_zh: "报表名中文名",
  dbl_myAnalysis_publish_dashboard_zh_placeholder: "请输入报表中文名",
  dbl_myAnalysis_publish_first_level_dir: "一级目录",
  dbl_myAnalysis_publish_second_level_dir: "二级目录",
  dbl_myAnalysis_publish_second_level_dir_placeholder: "特性目录选择",
  dbl_myAnalysis_publish_dashboard_task: "报表标签",
  dbl_myAnalysis_publish_dashboard_task_placeholder: "标签选择",
  dbl_myAnalysis_publish_person: "发布人",
  dbl_myAnalysis_publish_valid_length: "不可为空, 且长度不超过80",
  dbl_myAnalysis_publish_valid_first_dir: "请选择一个一级目录",
  dbl_myAnalysis_publish_valid_second_dir: "请选择一个二级目录",
  dbl_myAnalysis_publish_valid_task: "请选择一个报表标签",
  dbl_myAnalysis_publish_success: "发布成功，",
  dbl_myAnalysis_publish_view_detail: "查看详情",
  dbl_myAnalysis_publish_nothing: "无筛选器设置",
  dbl_myAnalysis_publish_select_info: "展示所有区服的去重用户数据",
  dbl_myAnalysis_publish_select_aggregating: "聚拢数据",

  // 删除提示
  dbl_myAnalysis_delete_title: "确定删除任务?",
  dbl_myAnalysis_delete_message: "将导致分析任务无法使用，删除任务无法恢复，请谨慎操作。",

  dbl_myAnalysis_lable: '标签',
  dbl_myAnalysis_chart_name: '图表名',
  dbl_myAnalysis_chart_type: '图表类型',
  dbl_myAnalysis_chart_data_source: '数据源',
  dbl_myAnalysis_chart_creator: '创建人',
  dbl_myAnalysis_operation: '操作',
  dbl_myAnalysis_create_new_chart: '新建图表',
  dbl_myAnalysis_exploratory_analysis: '探索分析',
  dbl_myAnalysis_can_not_delete_chart_title: "无法删除",
  dbl_myAnalysis_can_not_delete_chart_message: "当前图表已被引用，删除前请先取消图表引用。",
  dbl_myAnalysis_sure_to_delete_chart_title: "确定删除图表?",
  dbl_myAnalysis_sure_to_delete_dashboard_title: "确定删除报表?",
  dbl_myAnalysis_sure_to_unpublish_dashboard_title: "你想要取消发布报表吗？",
  dbl_myAnalysis_sure_to_unpublish_dashboard_message: "在取消发布后，报表将会从经分系统中移除。",
  dbl_myAnalysis_sure_to_delete_chart_message: "删除 {name} ？删除操作无法恢复，请谨慎操作。",
  dbl_myAnalysis_chart_search_placeholder: "搜索图表名、创建人或数据源",
  dbl_myAnalysis_chart_i_know: "我知道了",

  dbl_myAnalysis_top_others: '显示前几项值，并将其余值汇总为"其它"。',
  dbl_myAnalysis_top: "仅显示前几项值",
  dbl_myAnalysis_limit_100: "数值范围: 1-100",
  dbl_myAnalysis_limit_500: "数值范围: 1-500",
  
};